import { useCallback, useState, useEffect } from 'react';
// Helper function to collect expanded items from tree data
const collectExpandedItems = (items) => {
    const expanded = new Set();
    const walkTree = (nodes) => {
        nodes.forEach((node) => {
            if (node.expanded) {
                expanded.add(node.id);
            }
            if (node.children?.length) {
                walkTree(node.children);
            }
        });
    };
    walkTree(items);
    return expanded;
};
export const useTreeState = ({ activeItemId, items = [], }) => {
    // Initialize with items marked as expanded in tree data
    const [expandedItems, setExpandedItems] = useState(() => {
        return collectExpandedItems(items);
    });
    // Update expanded items when tree data changes
    useEffect(() => {
        const fromTreeData = collectExpandedItems(items);
        setExpandedItems((prev) => new Set([...prev, ...fromTreeData]));
    }, [items]);
    const toggleExpanded = useCallback((itemId) => {
        setExpandedItems((prev) => {
            const newSet = new Set(prev);
            if (newSet.has(itemId)) {
                newSet.delete(itemId);
            }
            else {
                newSet.add(itemId);
            }
            return newSet;
        });
    }, []);
    // simple inline checks
    const isItemActive = (itemId) => itemId === activeItemId;
    const isItemExpanded = (itemId) => expandedItems.has(itemId);
    return {
        expandedItems,
        toggleExpanded,
        isItemActive,
        isItemExpanded,
    };
};
